import fpApiUtil from "./fp-api-util";

const ANALYSIS = "factoryplan/analysis";

// 자원 목표 가동률(공장>스테이지>자원별 가동률/목표가동률/부하시간/가용시간 크로스탭) — 크로스탭 그리드용.
// AnalysisController#getResourceTargetUtilization(백엔드는 factoryplan/analysis/resource-target-utilization/utilization).
// 다른 크로스탭 화면과 같은 { crosstabHeader, chartHeader, data[].pivotData } 형태이되, 응답에
// `top`(단일 객체, analysisIndicator=FP_TARGET_UTILIZATION + crosstabHeader와 인덱스 1:1인
// pivotData)이 추가로 내려온다 — 그리드 상단 pinnedTopRowData(전체 목표 가동률 요약 행)의 소스.
// 이 화면은 시간 버킷을 지원하지 않는다(ResourceTargetUtilizationService#getResourceTargetUtilization이
// bucket.isHourBucket()이면 빈 결과 반환, ResrcUtilization/JobChangeTimeInfo와 동일 계열).
const getResrcTargetUtilization = (params) => fpApiUtil.postParams(`${ANALYSIS}/resource-target-utilization/utilization`, params);

// 같은 엔드포인트의 차트용 호출 — 그리드에서 클릭한 행(plantCd/stageCd/resourceCd)으로 드릴다운,
// useGrouping:true로 그 레벨까지 백엔드가 집계해서 내려준다(ResourceTargetUtilizationCrosstabDto.merge,
// GroupingLevel 참고, ResourceUtilization/JobChangeTimeInfo와 동일 계열). 컬럼 필터(changes)는
// 1차 미이관이라 항상 빈 객체로 보낸다(fp-report-screen-guide.md §A-6e와 동일 결정).
const getResrcTargetUtilizationChart = (params, changes) =>
  fpApiUtil.postFields(`${ANALYSIS}/resource-target-utilization/utilization`, { params, changes });

const fpResourceTargetUtilizationService = { getResrcTargetUtilization, getResrcTargetUtilizationChart };
export default fpResourceTargetUtilizationService;
